import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import { modalStore } from 'apps/modals/app';
import { ConfirmAction } from 'apps/modals/confirmAction/index';
import PropTypes from 'prop-types';

import SupportingFilesSection from 'apps/rfq/views/supportingFilesSection';

const SupportingFiles = observer(
  ({
    rfqManager,
    canUpdateFiles: forceCanUpdateFiles,
    supportingFiles: supportingFilesProp,
  }) => {
    let supportingFiles = [];
    let supportingFilesBeingAdded = [];

    if (rfqManager) {
      supportingFiles =
        rfqManager?.rfqApp?.jobSpec?.build.supportingFiles?.apps;
    } else if (supportingFilesProp) supportingFiles = supportingFilesProp;
    else return null;

    if (rfqManager)
      ({ supportingFilesBeingAdded } = rfqManager.rfqApp?.jobSpec?.build);

    const handleAddSupportingFiles = fileList => {
      if (fileList.length > 0) rfqManager.AddSupportingFiles(fileList);
    };

    const handleRemoveSupportingFile = supportingFile => {
      modalStore.SetModalComponent(ConfirmAction, {
        callBack: () => {
          supportingFile.SetIsBeingRemoved(true);
          rfqManager.RemoveSupportingFile(supportingFile.id, wasSuccessful => {
            if (!wasSuccessful) supportingFile.SetIsBeingRemoved(false);
          });
        },
        title: `Remove "${supportingFile.filename}" from this RFQ?`,
        undo: true,
      });
    };

    let canUpdateFiles = forceCanUpdateFiles;
    let supportingFilesRequirements = [];
    if (rfqManager) {
      const { fileRequirements, isUpdatable } = rfqManager.rfqApp;
      if (fileRequirements) {
        supportingFilesRequirements = fileRequirements.filter(
          fileRequirement => fileRequirement.type === 'SUPPORTING_FILE',
        );
      }
      if (canUpdateFiles === undefined || canUpdateFiles === null) {
        canUpdateFiles = isUpdatable;
      }
    }

    // Note(david): Fail safe, should not happen. This is to enforce a precondition on this component:
    // If rfqManager is null, then the prop canUpdateFiles has to be false, and supportingFileProp
    // has to have data. This happens in the OrderPage, where there's no rfqManager.
    if (!rfqManager) {
      canUpdateFiles = false;
    }

    return (
      <SupportingFilesSection
        supportingFiles={supportingFiles}
        supportingFilesBeingAdded={supportingFilesBeingAdded}
        supportingFilesRequirements={supportingFilesRequirements}
        onAddSupportingFiles={handleAddSupportingFiles}
        onRemoveSupportingFile={handleRemoveSupportingFile}
        shouldShowTooltip={false}
        canUpdateFiles={canUpdateFiles}
      />
    );
  },
);

SupportingFiles.propTypes = {
  rfqManager: PropTypes.object,
  canUpdateFiles: PropTypes.bool,
  supportingFiles: PropTypes.array,
};

export default withNamespaces()(SupportingFiles);
